module.exports = __webpack_public_path__ + "img/button_search.06f13705.png";